import { GridItem } from '@bnnvara/grids';
import Slider from '@bnnvara/slider';
import { Heading } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const ComposableSlider = ({ items, heading, renderCard, isBrand }) => {
  const enoughItems = items.length > 3;

  if (!enoughItems) {
    return null;
  }

  const itemsWithIndex = items.map((item, index) => ({ ...item, index }));

  return (
    <Fragment>
      {heading && !isBrand && (
        <GridItem
          columnStartSm="1"
          columnEndSm="span 12"
          columnStartMd="1"
          columnEndMd="span 12"
          columnStartLg="1"
          columnEndLg="span 12"
        >
          <Heading element="h2" variant="brand">
            {heading}
          </Heading>
        </GridItem>
      )}

      <GridItem
        columnStartSm="1"
        columnEndSm="span 12"
        columnStartMd="1"
        columnEndMd="span 12"
        columnStartLg="1"
        columnEndLg="span 12"
      >
        <Slider isBrand={isBrand}>{itemsWithIndex.map(renderCard)}</Slider>
      </GridItem>
    </Fragment>
  );
};

ComposableSlider.defaultProps = {
  items: [],
  heading: null,
  isBrand: false,
};

ComposableSlider.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      thumbnail: PropTypes.shape({
        url: PropTypes.string,
      }),
    })
  ),
  renderCard: PropTypes.func.isRequired,
  heading: PropTypes.string,
  isBrand: PropTypes.bool,
};

export default ComposableSlider;
